import { StatisticsApi } from '@hefe/store';
import ChartPickerComponent from '../chart-picker/chart-picker.component';

interface BasketballGameStatisticsComponentProps {
  from: string;
  till: string;
}

export default function BasketballGameStatisticsComponent(
  props: BasketballGameStatisticsComponentProps
) {
  const { data, isFetching } =
    StatisticsApi.useFetchBasketballGamesStatisticsQuery({
      from: props.from,
      till: props.till,
    });

  return <ChartPickerComponent charts={data ?? []} loading={isFetching} />;
}
